import { ref } from '@nuxtjs/composition-api'
import { stringifyHtml as stringify } from './helpers/stringifyHtml'

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function useStringifyHtml () {
  const stringHtml = ref<string | undefined>()

  async function stringifyHtml (html: string, maxLength?: number): Promise<void> {
    stringHtml.value = await stringify(html, maxLength)
  }

  return {
    stringHtml,
    stringifyHtml
  }
}
